import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import { useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

var serialize = require('serialize-javascript');

function Physical (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);


    const prevLocation = {
        pathname: '../job',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }
    const next = () =>{
        let nextLocation = {}

        nextLocation = {
            pathname: '../intervention',
            state: { d: d }
        }

        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const [stored, setStored] =  useState("")
    const [Age, setAge] =  useState("")


    // set control value and name to classic inputs using the custom Hook useInput
    const {value: Field53HospitalizedDoctorname, bind: bindField53HospitalizedDoctorname, reset: setField53HospitalizedDoctorname } = useInput('');
    const {value: Field5302HostipalEndDate, bind: bindField5302HostipalEndDate, reset: setField5302HostipalEndDate } = useInput('');
    const {value: Field5301HostipalBeginDate, bind: bindField5301HostipalBeginDate, reset: setField5301HostipalBeginDate } = useInput('');

    // radio input custom handleChange
    const [Field53Hospitalized, setField53Hospitalized] = useState("");
    const handleChangeField53Hospitalized = (e) => {
        let value = e.target.value
        setField53Hospitalized(value);
    }
    const [Field5303HostipalUntilNow, setField5303HostipalUntilNow] = useState(false);
    const handleChangeField5303HostipalUntilNow = (e) => {
        let value = !Field5303HostipalUntilNow
        setField5303HostipalUntilNow(value);
    }

    const {value: Field52Wounds, bind: bindField52Wounds, reset: setField52Wounds } = useInput('');
    const {value: Field5601HealedBeginDate, bind: bindField5601HealedBeginDate, reset: setField5601HealedBeginDate } = useInput('');
    const {value: Field5402IncapicityEndDate, bind: bindField5402IncapicityEndDate, reset: setField5402IncapicityEndDate } = useInput('');
    const {value: Field5401IncapicityBeginDate, bind: bindField5401IncapicityBeginDate, reset: setField5401IncapicityBeginDate } = useInput('');

    // radio input custom handleChange
    const [Field54Incapicity, setField54Incapicity] = useState("");
    const handleChangeField54Incapicity = (e) => {
        let value = e.target.value
        setField54Incapicity(value);
    }
    const [Field55Traitement, setField55Traitement] = useState("");
    const handleChangeField55Traitement = (e) => {
        let value = e.target.value
        setField55Traitement(value);
    }
    const [Field56Healed, setField56Healed] = useState("");
    const handleChangeField56Healed = (e) => {
        let value = e.target.value
        setField56Healed(value);
    }

    const [Field5403IncapicityUntilNow, setField5403IncapicityUntilNow] = useState(false);
    const handleChangeField5403IncapicityUntilNow = (e) => {
        let value = !Field5403IncapicityUntilNow
        setField5403IncapicityUntilNow(value);
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        const fetchData = () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            const age = localStorage.getItem('Age')
            setAge(age)
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);


            const physical = JSON.parse(localStorage.getItem('physical'))

            if (physical){
                setStored(true)
                setField53HospitalizedDoctorname(physical.Field53HospitalizedDoctorname)
                setField5302HostipalEndDate(physical.Field5302HostipalEndDate)
                setField5301HostipalBeginDate(physical.Field5301HostipalBeginDate)
                setField53Hospitalized(physical.Field53Hospitalized)
                setField5303HostipalUntilNow(physical.Field5303HostipalUntilNow)
                setField5402IncapicityEndDate(physical.Field5402IncapicityEndDate)
                setField5401IncapicityBeginDate(physical.Field5401IncapicityBeginDate)
                setField52Wounds(physical.Field52Wounds)
                setField5601HealedBeginDate(physical.Field5601HealedBeginDate)
                setField54Incapicity(physical.Field54Incapicity)
                setField55Traitement(physical.Field55Traitement)
                setField56Healed(physical.Field56Healed)
                setField5403IncapicityUntilNow(physical.Field5403IncapicityUntilNow)
            }
        };
        fetchData()
    }, []);
    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = (Field56Healed === "Yes" && !Field5601HealedBeginDate) ||
            Field52Wounds === ""||
            Field53Hospitalized === "" ||
            Field56Healed === "" ||
            Field54Incapicity === "" ||
            Field55Traitement === "" ||
             Field53HospitalizedDoctorname === "" ||
            (Field53Hospitalized === "Yes" && (Field5302HostipalEndDate === "" && Field5303HostipalUntilNow === false)) ||
            (Field53Hospitalized === "Yes" && Field5301HostipalBeginDate === "") ||
            (Field54Incapicity === "Yes" && Field5401IncapicityBeginDate === "") ||
            (Field54Incapicity === "Yes" && (Field5402IncapicityEndDate === "" && Field5403IncapicityUntilNow === false))


      //console.log(notValid)

        setNotValid(notValid)
        if (!notValid){
            let physical = {
                Field53HospitalizedDoctorname:Field53HospitalizedDoctorname,
                Field5302HostipalEndDate:Field5302HostipalEndDate,
                Field5301HostipalBeginDate:Field5301HostipalBeginDate,
                Field53Hospitalized:Field53Hospitalized,
                Field5303HostipalUntilNow:Field5303HostipalUntilNow,
                Field5402IncapicityEndDate:Field5402IncapicityEndDate,
                Field5401IncapicityBeginDate:Field5401IncapicityBeginDate,
                Field52Wounds:Field52Wounds,
                Field5601HealedBeginDate:Field5601HealedBeginDate,
                Field54Incapicity:Field54Incapicity,
                Field55Traitement:Field55Traitement,
                Field56Healed:Field56Healed,
                Field5403IncapicityUntilNow:Field5403IncapicityUntilNow
            }
            //let stringInfo = JSON.stringify(physical)
            let stringInfo = serialize(physical, {isJSON: true});
            localStorage.setItem("physical" , stringInfo)
            next()
        }

    }



    const { i18n } = useTranslation();
    // woluweb 2021 01 06 - added 'https://' or even '//' like in 0Home.js otherwise the links don't work here even if they work on homepage
    const url = '//' + i18n.t('CERTIFLINK')
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    {(Age < 16)?
                        <BreadCrumb n={5}/>:<BreadCrumb n={6}/>}
                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("CONSEQUENCESTITLE"): i18n.t("CONSEQUENCESTITLE") }</h3>
                            <h4 className={"text-primary"}>{ d? i18n.t("Les conséquences corporelles"): i18n.t("Les conséquences corporelles") }</h4>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }

                            <Form>
                                <div className="formlevel01">
                                    <FormGroup>
                                        <Label>{i18n.t("Nature des blessures")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="textarea" maxLength={5000} {...bindField52Wounds}
                                               placeholder={i18n.t("placeholderfield52Wounds")}
                                               rows={6}
                                               invalid={(NotValid && Field52Wounds === "") ? true : undefined}/>
                                        <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                    </FormGroup>
                                    <Alert color={'warning'}>
                                        <FontAwesomeIcon className="pre" icon={['fas', 'info-circle']} />&nbsp;
                                        <strong>{i18n.t("Information")}</strong>
                                        <hr className="message-inner-separator"/>
                                        <p>{i18n.t("field5601HealedBeginDateWarning")}</p>
                                        <a className={"btn btn-primary small"} href={url} rel="noopener noreferrer" target={"_blank"}><span
                                            className="glyphicon glyphicon-download-alt" aria-hidden="true"/> {i18n.t('Télécharger ce modèle de certificat médical')}</a>
                                    </Alert>
                                    <FormGroup check>
                                        <Label for="Field53Hospitalized" className={(NotValid && Field53Hospitalized === "") ? "text-danger" : "text"}>{ i18n.t('field53Hospitalized')  }  <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field53Hospitalized"  value="No"  onChange={handleChangeField53Hospitalized} checked={Field53Hospitalized === "No"} />
                                                {  i18n.t('NO') }
                                            </Label>
                                        </div>
                                        {Field53Hospitalized === "No" &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label>{i18n.t("Nom du médecin traitant")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindField53HospitalizedDoctorname}
                                                       placeholder={i18n.t("Entrer le nom du médecin traitant")}
                                                       invalid={(NotValid && Field53HospitalizedDoctorname === "") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                        </div>}
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field53Hospitalized" value="Yes"  onChange={handleChangeField53Hospitalized} checked={Field53Hospitalized === "Yes"} />
                                                {  i18n.t('YES') }
                                            </Label>
                                        </div>
                                        {Field53Hospitalized === "Yes" &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <h4>{i18n.t("Durée de l'hospitalisation")} <span className={"text-danger"}>*</span></h4>
                                                <Label>{i18n.t("Nom du médecin traitant et/ou de la clinique")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindField53HospitalizedDoctorname}
                                                       placeholder={i18n.t("Entrer le nom du médecin traitant et/ou de la clinique")}
                                                       invalid={(NotValid && Field53HospitalizedDoctorname === "") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field5301HostipalBeginDate")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="date" {...bindField5301HostipalBeginDate}
                                                       invalid={(NotValid && Field5301HostipalBeginDate === "") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field5302HostipalEndDate")} <span className={"text-warning"}>*</span></Label>

                                                <Input type="date" {...bindField5302HostipalEndDate}
                                                       invalid={(NotValid && Field5302HostipalEndDate === "") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                            <FormGroup check>
                                                <div className="checkbox">
                                                    <Label>
                                                        <Input type="checkbox" name="Field5303HostipalUntilNow" value="Now"  onChange={handleChangeField5303HostipalUntilNow} checked={Field5303HostipalUntilNow} />
                                                        {  i18n.t("J'ai été hospitalisé(e) jusqu'à présent") }
                                                    </Label>
                                                </div>
                                            </FormGroup>
                                        </div>}
                                    </FormGroup>

                                    <div>
                                        <FormGroup check>
                                            <Label for="Field54Incapicity" className={(NotValid && Field54Incapicity === "") ? "text-danger" : "text"}>
                                                { (Age > 25) && i18n.t('field54Incapicity') }
                                                { (Age > 15 && Age < 25) && i18n.t('field54Incapicity1625') }
                                                { (Age < 16) && i18n.t('field54Incapicity16') } <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field54Incapicity"  value="No"  onChange={handleChangeField54Incapicity} checked={Field54Incapicity === "No"} />
                                                    {  i18n.t('NO') }
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field54Incapicity" value="Yes"  onChange={handleChangeField54Incapicity} checked={Field54Incapicity === "Yes"} />
                                                    {  i18n.t('YES') }
                                                </Label>
                                            </div>
                                            {Field54Incapicity === "Yes" &&
                                            <div className="formlevel02">
                                                <FormGroup>
                                                    <Label>{i18n.t("field5401IncapicityBeginDate")} <span className={"text-danger"}>*</span></Label>
                                                    <Input type="date" {...bindField5401IncapicityBeginDate}
                                                           invalid={(NotValid && Field5401IncapicityBeginDate === "") ? true : undefined}/>
                                                    <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label>{i18n.t("field5402IncapicityEndDate")} <span className={"text-warning"}>*</span></Label>

                                                    <Input type="date" {...bindField5402IncapicityEndDate}
                                                           invalid={(NotValid && Field5402IncapicityEndDate === "") ? true : undefined}/>
                                                    <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <div className="checkbox">
                                                    <Label>
                                                        <Input type="checkbox" name="Field5403IncapicityUntilNow"   onChange={handleChangeField5403IncapicityUntilNow} checked={Field5403IncapicityUntilNow} />
                                                        {  i18n.t("J'ai été en incapicité jusqu'à présent") }
                                                    </Label>
                                                    </div>
                                                </FormGroup>
                                            </div>}
                                        </FormGroup>
                                        <FormGroup check>
                                            <Label for="Field55Traitement" className={(NotValid && Field55Traitement === "") ? "text-danger" : "text"}>{   i18n.t('field55Traitement')  }  <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field55Traitement"  value="No"  onChange={handleChangeField55Traitement} checked={Field55Traitement === "No"} />
                                                    {  i18n.t('NO') }
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field55Traitement" value="Yes"  onChange={handleChangeField55Traitement} checked={Field55Traitement === "Yes"} />
                                                    {  i18n.t('YES') }
                                                </Label>
                                            </div>
                                        </FormGroup>
                                        <FormGroup check>
                                            <Label for="Field56Healed" className={(NotValid && Field56Healed === "") ? "text-danger" : "text"}>{   i18n.t('field56Healed')  }  <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field56Healed"  value="No"  onChange={handleChangeField56Healed} checked={Field56Healed === "No"} />
                                                    {  i18n.t('NO') }
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field56Healed" value="Yes"  onChange={handleChangeField56Healed} checked={Field56Healed === "Yes"} />
                                                    {  i18n.t('YES') }
                                                </Label>
                                            </div>
                                            {Field56Healed === "Yes" &&
                                            <div className="formlevel02">
                                                <FormGroup>
                                                    <Label>{i18n.t("field5601HealedBeginDate")} <span className={"text-danger"}>*</span></Label>
                                                    <Input type="date" {...bindField5601HealedBeginDate}
                                                           invalid={(NotValid && Field56Healed === "Yes" && !Field5601HealedBeginDate) ? true : undefined}/>
                                                    <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                                </FormGroup>
                                            </div>}
                                        </FormGroup>
                                    </div>






                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }</button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }</button>
                                    </div>
                                    }
                                </div>

                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Physical

